export const requestEnvironmentAtmaca = (data: any) => ({
  ...data,
  environment: 'Alice',
})
